export default __webpack_public_path__ + "static/media/leftarrow.1f911613.svg";